// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"K--z","categoryName":"L--z","categoryImage":"M--z","categoryContent":"N--z","bottomAligned":"O--z"};